import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getIncident} from "../../../api/maintenance/IncidentService";
import React, {useEffect, useState} from "react";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";
import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";
import {IncidentInfo} from "./subPages/IncidentInfo";
import {ContentCategory} from "../../../constant/CodeSpecNum";
import {skeleton} from "../../../redux/slice/apiSlice";
import {selectHandlers} from "../../../api/handler/handlerService";
import {changeProgressStatusValue, changeStatusNumericValue} from "../../../redux/slice/contentSlice";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {IncidentReport} from "./report/IncidentReport";

const DEFAULT_TABS = [
    {clicked: true, name: "기본정보"},
    {clicked: false, name: "장애보고서"},
    {clicked: false, name: "이력관리"},
];

function IncidentTab(){
    const { id } = useParams();
    const dispatch = useDispatch();
    const refreshContent = useSelector(state => state.status.refreshContent);
    const statusNumericValue = useSelector(state => state.content.statusNumericValue);

    const [incident, setIncident] = useState({});
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const [tabs, setTabs] = useState(DEFAULT_TABS);
    const navigate = useNavigate();

    useEffect(() => {
        setIncident({});
        setAssets([]);
        setHandler([]);
        setTabs(DEFAULT_TABS);
        dispatch(changeStatusNumericValue(0));
        dispatch(changeProgressStatusValue({}));
    }, [id, dispatch]);

    useEffect(() =>{
        let cancelled = false;

        Promise.all([
            getIncident(id),
            selectHandlers({ contentId: id, contentCategory: ContentCategory.INCIDENT }),
            getContentStatus({contentId : id, contentCategory : ContentCategory.INCIDENT})
        ]).then(([incidentResponse, handlersResponse, statusNumericValueResponse]) => {
            if (cancelled) return;

            if(incidentResponse.status === 201) {
                if (incidentResponse.data.errorCode = 'AUTHORITY') {
                    alert(incidentResponse.data.reason)
                    navigate(-1)
                }
            }

            setIncident(incidentResponse.data);

            if (statusNumericValueResponse && statusNumericValueResponse.status === 200) {
                const numericValue = statusNumericValueResponse.data.statusNumericValue;
                dispatch(changeStatusNumericValue(numericValue));
                dispatch(changeProgressStatusValue(statusNumericValueResponse.data));
            }

            setAssets(incidentResponse.data.maintenanceAssets?.map(each => each.assets));
            setHandler(handlersResponse.data);
        }).finally(() => {
            if (!cancelled) {
                dispatch(skeleton(false));
            }
        });

        return () => {
            cancelled = true;
        };
    }, [id, dispatch, refreshContent, navigate]);

    if(Object.keys(incident).length > 0) {
        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                <DetailHeroSummaryProvider>
                    <DetailTabBar tabs={tabs} setTabs={setTabs} />
                    {tabs[0].clicked && <IncidentInfo id={id} incident={incident} assets={assets} handler={handler} statusNumericValue={statusNumericValue} />}
                    {tabs[1].clicked && <IncidentReport id={id} incident={incident} setIncident={setIncident} assets={assets} handler={handler} statusNumericValue={statusNumericValue} />}
                    {tabs[2].clicked && <CommonHistoryList id={id} tableName={"장애관리"} />}
                </DetailHeroSummaryProvider>
            </div>
        );
    }
}

export {IncidentTab}
